module.exports = __webpack_public_path__ + "img/Deleteall.6ff0396e.svg";